import React from "react"
import { Accordion, Col, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Connection, deleteConnection, deleteObstacle, RootState, updateConnection, updateObstacle } from ".."
import { ConnectionFormEditor } from "./ConnectionFormEditor"
import { ObstacleFormEditor } from "./ObstacleFormEditor"

export { FormEditor }

function FormEditor() {
  const inputConfiguration = useSelector((state: RootState) => state.inputConfiguration)
  const dispatch = useDispatch()
  return (
    <Container style={{
      maxWidth: '100%'
    }}>
    <Row>
    <Col xs={12} sm={12} md={12} lg={6} xl={6}>
    <h2
      className='obstacleHeadline'
    >
      Components
    </h2>
    <Accordion>
      {inputConfiguration.obstacles.map((obstacle) => {
        return <ObstacleFormEditor
              key={obstacle.id}
              obstacle={obstacle}
              onChange={obstacle => dispatch(updateObstacle(obstacle))}
              onDelete={() => dispatch(deleteObstacle(obstacle.id))}
            />
      })}
    </Accordion>
    </Col>
    <Col xs={12} sm={12} md={12} lg={6} xl={6}>
      <h2
        className='connectionHeadline'
      >
        Connections
      </h2>
      <Accordion>
        {inputConfiguration.connections.map((connection) => {
          return <ConnectionFormEditor
                key={connection.id}
                connection={connection}
                onChange={connection => dispatch(updateConnection(connection))}
                onDelete={() => dispatch(deleteConnection(connection.id))}
              />
        })}
      </Accordion>
    </Col>
    </Row>
    </Container>
  )
}
